export default __webpack_public_path__ + "static/media/ico-document2.8ed1981a.svg";